import { ConfirmSwal } from '@vendor/libs/sweetalert2/sweetalert2';
import { i18n } from '@vendor/libs/lang/lang';
import { $ } from '@vendor/libs/jquery/jquery';
const _OrderFormProducersEditHandler = (function () {
    const body = $('body');
    const tableBody = $('[data-app-producers="table"] tbody');
    const deleteRow = (id) => {
        tableBody.find(`tr[data-app-id="${id}"]`).remove();
    };
    return {
        // Public functions
        init: function () {
            body.on('click', '[data-app-delete="button"]', function () {
                const id = $(this).attr('data-app-id');
                if (!id) {
                    return;
                }
                ConfirmSwal.fire({
                    text: i18n.trans('models/order_form_producers.pages.edit.delete.confirm'),
                }).then((response) => {
                    if (response.isConfirmed) {
                        deleteRow(id);
                    }
                });
            });
        },
    };
})();
window.OrderFormProducersEditHandler = _OrderFormProducersEditHandler;
